import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';

export const StyledSubHeaderWrapper = styled.div`
  margin-top: 44px;
  display: flex;
  align-items: center;
  height: 52px;

  @media ${mediaConfined} {
    height: 68px;
  }
`;
